import { lazy } from 'react';

export const PromoContractsPage = lazy(
  () =>
    import(
      /* webpackPreload: true */
      /* webpackChunkName: "PromoContractsPage" */
      './PromoContractsPage'
    ),
);
